import Service from "./service";

class ReportsService extends Service {

  constructor(unauthorized=false) {
    super("REPORTS_SERVICE", unauthorized);
  }

  // Endpoint to retrieve securities
  getSecurities = () => {
    return this.get('/security');
  }

  getReports = (role, institutionCode) => {
    return this.get(`/reports/${role}`, {institutionCode: institutionCode});
  }

  sendReport = (isin, reportTitle, reportType, paymentDate, user) => {
    const encodedIsin = encodeURIComponent(isin);
    const encodedReportTitle = encodeURIComponent(reportTitle);
    const encodedReportType = encodeURIComponent(reportType);

    return this.patch(`/reports/${encodedReportType}/${encodedIsin}/${encodedReportTitle}/${paymentDate}/maker`, {}, {
      maker: user
    });
  }

  retrieveReport = (reportType, isin, reportTitle, paymentDate) => {
    const encodedReportType = encodeURIComponent(reportType);
    const encodedReportTitle = encodeURIComponent(reportTitle);
    const encodedIsin = encodeURIComponent(isin);
    const encodedPaymentDate = encodeURIComponent(paymentDate);
    return this.get(`/reports/${encodedReportType}/${encodedIsin}/${encodedReportTitle}/${encodedPaymentDate}`);
  }

  retrieveReportIssuer = (reportType, isin, reportTitle, paymentDate, user) => {
    const encodedReportType = encodeURIComponent(reportType);
    const encodedReportTitle = encodeURIComponent(reportTitle);
    const encodedIsin = encodeURIComponent(isin);
    const encodedPaymentDate = encodeURIComponent(paymentDate);
    return this.patch(`/reports/${encodedReportType}/${encodedIsin}/${encodedReportTitle}/${encodedPaymentDate}/issuer`, {}, {
      issuer: user
    });
  }

  uploadReport = (reportType, isin, reportTitle, paymentDate, fileName, base64File) => {
    const encodedReportType = encodeURIComponent(reportType);
    const encodedReportTitle = encodeURIComponent(reportTitle);
    const encodedIsin = encodeURIComponent(isin);
    const encodedPaymentDate = encodeURIComponent(paymentDate);
    const encodedFileName = encodeURIComponent(fileName);

  const requestBody = {
    fileData: base64File,
    fileName: encodedFileName
  };

  console.log(`body: `, requestBody);
  console.log(`/reports/${encodedReportType}/${encodedIsin}/${encodedReportTitle}/${encodedPaymentDate}/upload`);

    return this.patch(`/reports/${encodedReportType}/${encodedIsin}/${encodedReportTitle}/${encodedPaymentDate}/upload`, {
      fileName: fileName
    },
  {
    body: requestBody
  });
  }

    // Endpoint to generate report(CaMaker)
  generateReport = (reportType, reportTitle, isin, paymentDate) => {
    const encodedReportType = encodeURIComponent(reportType);
    const encodedReportTitle = encodeURIComponent(reportTitle);
    const encodedIsin = encodeURIComponent(isin);
    const encodedPaymentDate = encodeURIComponent(paymentDate);
    return this.post(`/reports/${encodedReportType}/${encodedIsin}/${encodedReportTitle}/${encodedPaymentDate}`);
  }

  checkerSendReport = (reportType, reportTitle, isin, paymentDate, user) => {
    const encodedReportType = encodeURIComponent(reportType);
    const encodedReportTitle = encodeURIComponent(reportTitle);
    const encodedIsin = encodeURIComponent(isin);
    const encodedPaymentDate = encodeURIComponent(paymentDate);
    return this.patch(`/reports/${encodedReportType}/${encodedIsin}/${encodedReportTitle}/${encodedPaymentDate}/checker/submit`, {}, {
      checker: user
    });
  }

  checkerRejectReport = (reportType, reportTitle, isin, paymentDate, user, comment) => {
    const encodedReportType = encodeURIComponent(reportType);
    const encodedReportTitle = encodeURIComponent(reportTitle);
    const encodedIsin = encodeURIComponent(isin);
    const encodedPaymentDate = encodeURIComponent(paymentDate);
    return this.patch(`/reports/${encodedReportType}/${encodedIsin}/${encodedReportTitle}/${encodedPaymentDate}/checker/reject`, {}, {
      checker: user,
      comment: comment
    });
  }
}

export default ReportsService;
